import DocumentRenderer from "./DocumentRenderer";
export withDocumentRenderer from "./withDocumentRenderer";
export default DocumentRenderer;
